// Street-level reverse geocoding from the browser (OpenStreetMap Nominatim).
export async function reverseGeocode(lat, lng) {
  try {
    const r = await fetch(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&zoom=18&addressdetails=1&lat=${lat}&lon=${lng}`, { headers: { "Accept-Language": "en" }, signal: AbortSignal.timeout?.(5000) });
    const j = await r.json(); const a = j.address || {};
    const street = [a.house_number, a.road].filter(Boolean).join(" ");
    const city = a.city || a.town || a.village || a.hamlet || a.county || "";
    return [street, city, [a.state, a.postcode].filter(Boolean).join(" ")].filter(Boolean).join(", ") || j.display_name || "";
  } catch { return ""; }
}
